// pages/Oati/OattPointToPointPage.tsx
import OattRatesPage from './OattRates';

const OattPointToPointPage = () => <OattRatesPage pageType="point-to-point" />;

export default OattPointToPointPage;
